/* ==========================================================================
   Made of Better Things — motion playground
   Motion.dev (vanilla) + the page's existing behaviour
   ========================================================================== */

(function () {
// Motion.dev is loaded by the <script type="module"> tag in the section (ESM from CDN).
// If it fails to load, fall back to a static page rather than breaking anything.
const noMotion = !window.Motion;
const M = window.Motion || {
  animate: () => {}, hover: () => {}, stagger: () => 0,
  inView: (el, cb) => { cb(); },
};
const { animate, inView, hover, stagger } = M;

const root = document.querySelector(".cookbook-v2");
if (!root) return;
const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches || noMotion;

/* ------------------------------------------------------------------
   MOTION PLAYGROUND — tweak these three objects, nothing else needed
   ------------------------------------------------------------------ */
const SPRING = {
  hero:  { type: "spring", stiffness: 100, damping: 15 },
  panel: { type: "spring", stiffness: 120, damping: 20 },
  cta:   { type: "spring", stiffness: 400, damping: 12 },  // low damping = elastic
  rule:  { type: "spring", stiffness: 70,  damping: 9 },   // line reveal: draws past, settles back
};
// Button shift: ultra-fast ease-out (no spring — a bouncing shadow reads as wobble, not weight)
const SHIFT = {
  ease:   { duration: 0.18, ease: [0.16, 1, 0.3, 1] },
  flat:   "0px 0px 0px 0px rgba(43,46,41,0), 0px 0px 0px 0px rgba(43,46,41,0)",
  studio: "0px 18px 40px -14px rgba(43,46,41,0.45), 0px 4px 10px -6px rgba(43,46,41,0.18)",
};

/* 0. BUY LINKS — the hero buttons scroll down to the buy block. Every other
   "Get the book" (the three buy strips and the bottom bar) goes straight to
   checkout, using the same link as the buy block's own button. If this script
   ever fails, those buttons still work: they fall back to scrolling to the
   buy block. */
const checkoutBtn = root.querySelector("#buy .btn");
const checkoutHref = checkoutBtn ? checkoutBtn.getAttribute("href") : "";
if (checkoutHref && checkoutHref.charAt(0) !== "#") {
  root.querySelectorAll(".rail-buy .btn, #stick .btn").forEach((a) => a.setAttribute("href", checkoutHref));
}

/* 0b. IN-PAGE LINKS — the hero "Get the book", "What's in it", "Free recipe"
   and "Try a recipe free" scroll smoothly to their section WITHOUT adding
   #buy / #recipe to the address. With nothing left in the address, a refresh
   or the Back button has nowhere to jump to except the hero. */
root.querySelectorAll('a[href^="#"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    const id = a.getAttribute("href").slice(1);
    const target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  });
});

/* 1. HERO TITLE POP — page load, slide up 30px + fade, spring (100 / 15) */
// (v2: the hero title is typed in with the section titles below — see TYPEWRITER)

/* 2. CHAPTER CARD SCROLL FADE — inView on each .panel: fade + scale .95 → 1
   Only one panel is display:grid at a time (the chip tabs), so inView fires
   for the visible one; switching chips replays the entrance on the new panel. */
const panels = root.querySelectorAll(".panel");
function revealPanel(panel) {
  if (reduce) { panel.style.opacity = 1; panel.style.transform = "none"; return; }
  animate(panel, { opacity: [0, 1], scale: [0.95, 1] }, SPRING.panel);
}
panels.forEach((panel) => {
  panel.style.opacity = 0;
  inView(panel, () => revealPanel(panel), { amount: 0.25 });
});

/* 3. STICKY BAR HOVER — elastic +4% scale on the bar's CTA */
const stickCta = root.querySelector("[data-stick-cta]");
if (stickCta && !reduce) {
  hover(stickCta, (el) => {
    animate(el, { scale: 1.04 }, SPRING.cta);
    return () => animate(el, { scale: 1 }, SPRING.cta);   // runs on hover end
  });
}

/* 4. THE BUTTON SHIFT — every primary CTA: -3px lift + flat → studio shadow */
if (!reduce) {
  root.querySelectorAll(".btn:not(.btn-line)").forEach((btn) => {
    btn.style.boxShadow = SHIFT.flat;
    hover(btn, (el) => {
      animate(el, { y: -3, boxShadow: SHIFT.studio }, SHIFT.ease);
      return () => animate(el, { y: 0, boxShadow: SHIFT.flat }, SHIFT.ease);
    });
  });
}

/* 5. FLUID LINE REVEALS — each section's rule draws left → right on entry */
root.querySelectorAll("[data-rule]").forEach((rule) => {
  if (reduce) { rule.style.transform = "none"; return; }
  inView(rule, () => { animate(rule, { scaleX: [0, 1] }, SPRING.rule); },
    { amount: "some", margin: "0px 0px -12% 0px" });
});

/* 5b. TESTIMONIALS — with eight of them, landing together reads flat.
   Each card lifts in just behind the one before it. */
const quotes = root.querySelectorAll("#proof .q");
if (!reduce && quotes.length > 3) {
  quotes.forEach((q) => { q.style.opacity = 0; });
  inView(root.querySelector("#proof .proof"), () => {
    animate(quotes, { opacity: [0, 1], y: [14, 0] },
      { duration: 0.5, delay: stagger(0.06), ease: [0.2, 0.7, 0.3, 1] });
  }, { amount: 0.1 });
}

/* 5c. ABOUT — metrics and qualifier lines assemble on an elastic spring
   (stiffness 90 / damping 14). Whole numbers count up as they slide in;
   anything else (4.9, 13M+) just slides in, since counting it looks wrong. */
const ABOUT_SPRING = { type: "spring", stiffness: 90, damping: 14 };

const metrics = root.querySelectorAll("#metrics .metric");
if (metrics.length && !reduce) {
  metrics.forEach((m) => { m.style.opacity = 0; });
  inView(root.querySelector("#metrics"), () => {
    animate(metrics, { opacity: [0, 1], y: [22, 0] }, { ...ABOUT_SPRING, delay: stagger(0.08) });
    metrics.forEach((m) => {
      const n = m.querySelector(".mn");
      if (!n) return;
      const raw = n.textContent.trim();
      const match = raw.match(/^(\d+)(\D*)$/);          // "50", "7+", "120k" → count; "4.9" → leave
      if (!match) return;
      const to = parseInt(match[1], 10), suffix = match[2] || "";
      if (!to) return;
      let t0 = null;
      requestAnimationFrame(function tick(ts) {
        if (!t0) t0 = ts;
        const p = Math.min((ts - t0) / 1100, 1);
        n.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))) + (p === 1 ? suffix : "");
        if (p < 1) requestAnimationFrame(tick);
        else n.textContent = raw;                       // restore exactly what the setting said
      });
    });
  }, { amount: 0.4 });
}

const quals = root.querySelectorAll("[data-qual]");
if (quals.length && !reduce) {
  quals.forEach((q) => { q.style.opacity = 0; });
  inView(root.querySelector(".target-audience"), () => {
    animate(quals, { opacity: [0, 1], x: [-14, 0] }, { ...ABOUT_SPRING, delay: stagger(0.07) });
  }, { amount: 0.3 });
}

/* ------------------------------------------------------------------
   v2 — FOCUS SCROLL + TYPEWRITER TITLES
   ------------------------------------------------------------------ */
const FOCUS = {
  dim: 0.55,      // opacity of the page you've left / haven't reached yet
  scale: 0.985,   // how far a page sits "back" before you zoom into it
};
const TYPE = {
  perChar: 45,    // milliseconds between characters
  holdCaret: 600, // milliseconds the caret stays after the last character
};

/* 6. FOCUS SCROLL — done in CSS (animation-timeline: view()) so it runs on
   the compositor. This block is only the fallback for browsers without it:
   a class toggle when a page crosses the middle band of the viewport. */
if (!reduce && !CSS.supports("animation-timeline: view()")) {
  const io = new IntersectionObserver(
    (es) => es.forEach((e) => e.target.classList.toggle("focus", e.isIntersecting)),
    { rootMargin: "-30% 0px -30% 0px", threshold: 0 }   // the middle 40% band of the viewport
  );
  root.querySelectorAll(".sec").forEach((s) => io.observe(s));
}

/* 7. TYPEWRITER TITLES — the hero headline and every section title write
   themselves in every time they come on screen, scrolling down or up.
   - Typing starts the moment any part of the title appears, so a title is
     never sitting blank on screen.
   - A title only resets once it is completely off screen.
   - Each title runs its own simple timer. Starting or resetting cancels the
     previous run completely, so letters can never be left half shown. */
function prepareTypewriter(h) {
  const text = h.textContent.trim();
  h.textContent = "";
  const wrap = document.createElement("span"); wrap.className = "tw";
  text.split(" ").forEach((word, i, arr) => {
    const w = document.createElement("span"); w.className = "w";
    for (const c of word) {
      const s = document.createElement("span"); s.className = "ch"; s.textContent = c; w.appendChild(s);
    }
    wrap.appendChild(w);
    if (i < arr.length - 1) wrap.appendChild(document.createTextNode(" "));   // real space → normal wrapping
  });
  const caret = document.createElement("span"); caret.className = "caret"; caret.setAttribute("aria-hidden", "true");
  wrap.appendChild(caret);
  h.appendChild(wrap);
  h.setAttribute("aria-label", text);
  return wrap;
}

function typeIn(h) {
  const wrap = prepareTypewriter(h);
  const chars = Array.prototype.slice.call(wrap.querySelectorAll(".ch"));
  const showAll = () => chars.forEach((c) => (c.style.opacity = 1));
  if (reduce) { showAll(); return; }
  let state = "idle", ticker = null, caretTimer = null;
  const stopTimers = () => { clearInterval(ticker); clearTimeout(caretTimer); ticker = null; caretTimer = null; };
  const run = () => {
    stopTimers();
    state = "typing";
    chars.forEach((c) => (c.style.opacity = 0));
    wrap.classList.add("typing");
    let i = 0;
    ticker = setInterval(() => {
      if (i < chars.length) { chars[i].style.opacity = 1; i++; return; }
      clearInterval(ticker); ticker = null;
      showAll();                                   // belt and braces: every letter on
      caretTimer = setTimeout(() => { wrap.classList.remove("typing"); state = "done"; }, TYPE.holdCaret);
    }, TYPE.perChar);
  };
  const reset = () => {
    stopTimers();
    chars.forEach((c) => (c.style.opacity = 0));
    wrap.classList.remove("typing");
    state = "idle";
  };
  new IntersectionObserver((es) => es.forEach((e) => {
    if (e.isIntersecting) { if (state === "idle") run(); }
    else if (state !== "idle") reset();
  }), { threshold: 0 }).observe(h);
  // If the tab is hidden mid-typing (timers pause), finish the line on return.
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden && state === "typing") { stopTimers(); showAll(); wrap.classList.remove("typing"); state = "done"; }
  });
}

const heroTitle = root.querySelector("[data-motion-hero]");
if (heroTitle) typeIn(heroTitle);
root.querySelectorAll(".sec-head > h2").forEach((h2) => typeIn(h2));

/* ==========================================================================
   Existing page behaviour (unchanged, just moved here)
   ========================================================================== */

// Marquee strip is rendered by Liquid (gallery blocks); JS only drives the drift/drag
const rail = root.querySelector(".mq"), track = root.querySelector("#mq");
if (rail && track && track.children.length) {
  const half = () => track.scrollWidth / 2;
  let held = false, dragging = false, startX = 0, startLeft = 0, visible = true, pos = 0;
  function step() {
    const hw = half();
    if (!reduce && visible && !dragging && !held) { pos += 0.6; rail.scrollLeft = pos; }
    else { pos = rail.scrollLeft; }
    if (hw > 0) {
      if (pos >= hw) { pos -= hw; rail.scrollLeft = pos; }
      else if (pos < 0) { pos += hw; rail.scrollLeft = pos; }
    }
    requestAnimationFrame(step);
  }
  rail.addEventListener("pointerdown", (e) => {
    dragging = true; startX = e.clientX; startLeft = rail.scrollLeft;
    rail.classList.add("dragging"); rail.setPointerCapture(e.pointerId);
  });
  rail.addEventListener("pointermove", (e) => { if (dragging) rail.scrollLeft = startLeft - (e.clientX - startX); });
  ["pointerup", "pointercancel", "pointerleave"].forEach((ev) => rail.addEventListener(ev, () => {
    if (dragging) { dragging = false; rail.classList.remove("dragging"); pos = rail.scrollLeft; }
  }));
  rail.addEventListener("mouseenter", () => { held = true; });
  rail.addEventListener("mouseleave", () => { held = false; pos = rail.scrollLeft; });
  rail.addEventListener("touchstart", () => { held = true; }, { passive: true });
  ["touchend", "touchcancel"].forEach((ev) => rail.addEventListener(ev, () => { held = false; pos = rail.scrollLeft; }, { passive: true }));
  rail.addEventListener("focusin", () => { held = true; });
  rail.addEventListener("focusout", () => { held = false; pos = rail.scrollLeft; });
  new IntersectionObserver((es) => es.forEach((e) => { visible = e.isIntersecting; }), { threshold: 0 }).observe(rail);
  document.addEventListener("visibilitychange", () => { if (document.hidden) visible = false; });
  requestAnimationFrame(step);
}

// Pause the hero drift when off-screen
const heroImg = root.querySelector(".hero-img");
if (heroImg) {
  new IntersectionObserver((es) => es.forEach((e) => e.target.classList.toggle("paused", !e.isIntersecting)), { threshold: 0 }).observe(heroImg);
  document.addEventListener("visibilitychange", () => heroImg.classList.toggle("paused", document.hidden));
}

// Chapter chips → panels (replays the Motion spring entrance)
const chips = root.querySelectorAll(".chip");
chips.forEach((c) => c.addEventListener("click", () => {
  const i = parseInt(c.getAttribute("data-i"), 10);
  chips.forEach((x, n) => x.classList.toggle("sel", n === i));
  panels.forEach((p, n) => { p.classList.toggle("on", n === i); if (n === i) revealPanel(p); });
}));

// Benefit cards stagger
const bio = new IntersectionObserver((es) => es.forEach((e) => {
  if (!e.isIntersecting) return;
  const i = [].indexOf.call(e.target.parentNode.children, e.target);
  setTimeout(() => e.target.classList.add("in"), i * 90);
  bio.unobserve(e.target);
}), { rootMargin: "0px 0px -10% 0px", threshold: 0.12 });
root.querySelectorAll("[data-ben]").forEach((b) => bio.observe(b));

// Generic reveals
const io = new IntersectionObserver((es) => es.forEach((e) => {
  if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
}), { rootMargin: "0px 0px -10% 0px", threshold: 0.05 });
root.querySelectorAll(".rev").forEach((el) => io.observe(el));

const rio = new IntersectionObserver((es) => es.forEach((e) => {
  if (e.isIntersecting) { e.target.classList.add("in"); rio.unobserve(e.target); }
}), { rootMargin: "0px 0px -14% 0px", threshold: 0.15 });
root.querySelectorAll("[data-rail]").forEach((r) => rio.observe(r));

// Stat counters
const st = root.querySelector("#stats");
if (st) {
  new IntersectionObserver((es, o) => es.forEach((e) => {
    if (!e.isIntersecting) return; o.disconnect();
    st.querySelectorAll(".n").forEach((n) => {
      const to = parseInt(n.dataset.to, 10);
      if (reduce || to === 0) { n.textContent = to; return; }
      let t0 = null;
      requestAnimationFrame(function tick(ts) {
        if (!t0) t0 = ts;
        const p = Math.min((ts - t0) / 900, 1);
        n.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      });
    });
  }), { threshold: 0.4 }).observe(st);
}

// Nav turns solid the moment the hero photo stops sitting behind it.
// Measured live from the photo's position on screen, so it survives any
// layout change (svh quirks, mobile chrome, resize, editor reloads).
const navEl = root.querySelector("nav");
const heroMedia = root.querySelector(".hero-media");
function navState() {
  if (!navEl) return;
  const bottom = heroMedia ? heroMedia.getBoundingClientRect().bottom : 0;
  navEl.classList.toggle("solid", bottom <= 80);
}

// Sticky bar show/hide.
// The bar is moved to the end of <body> so no theme wrapper (transform,
// contain, filter) can stop it pinning to the bottom of the screen.
// Everything is measured from positions on screen rather than window.scrollY,
// and scroll is listened for in the capture phase, so it keeps working even
// if the theme scrolls an inner container instead of the window.
const stick = root.querySelector("#stick"), by = root.querySelector("#buy"), hero = root.querySelector(".hero");
if (stick && stick.parentNode !== document.body) document.body.appendChild(stick);
let lastTop = null;
function stickState() {
  if (!stick || !by) return;
  const hr = hero ? hero.getBoundingClientRect() : null;
  const past = hr ? hr.bottom < hr.height * 0.15 : true;
  const rct = by.getBoundingClientRect();
  const buyVisible = rct.top < innerHeight * 0.9 && rct.bottom > 0;
  const top = hr ? hr.top : 0;
  const goingUp = lastTop !== null && top > lastTop + 4; lastTop = top;
  stick.classList.toggle("up", past && !buyVisible && !goingUp);
}
let ticking = false;
function onScroll() {
  if (ticking) return; ticking = true;
  requestAnimationFrame(() => { ticking = false; stickState(); navState(); });
}
document.addEventListener("scroll", onScroll, { passive: true, capture: true });
addEventListener("resize", () => requestAnimationFrame(() => { stickState(); navState(); }), { passive: true });
addEventListener("load", () => { stickState(); navState(); });
stickState(); navState();
})();